import React, { useState, useEffect, useRef } from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Skeleton } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

import { toast, Slide, Flip } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DeleteIcon from '@mui/icons-material/Delete';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { setProjectInfo, setProjectData, setEditProjList, setEditProjIdx, setCutList } from '@modules/editor';
import LoadingComponent from '../../../../_commons/LoadingComponent';

import '@resources/assets/styles/editor.scss';

import api from '@utils/axiosInstance';

function EditProjectList({ setIsLoading }) {
    const { t } = useTranslation();
    const { uuid } = useParams();

    const vodInfo = useSelector(state => state.media.vodInfo);
    const editProjList = useSelector(state => state.editor.editProjList);
    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);

    const [editProjectList, setEditProjectList] = useState([]);
    const [isFetched, setIsFetched] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const toastId = useRef();
    var flag = 0;
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [projectToDelete, setProjectToDelete] = useState(null);

    useEffect(() => {
        if (editProjList) {
            api({
                method: 'post',
                url: '/editor/getList',
                data: {
                    tk: userToken,
                    uuid: uuid,
                    ogc: organizationData.organization_code,
                }
            })
                .then((response) => {
                    if (response.data.code == 100) {
                        setEditProjectList(response.data.data);
                        setIsFetched(true);
                        dispatch(setEditProjList(response.data.data));
                    }
                    else {
                        toast.error(t("vod.manage.editor_tab.failed_to_load_subtitles"), {
                            position: "top-center",
                            autoClose: 2000,
                            theme: "colored",
                            className: 'rotateY animated',
                            transition: Flip
                        });
                    }
                })
                .catch((error) => {
                    toast.error(t("vod.manage.editor_tab.failed_to_load_subtitles"), {
                        position: "top-center",
                        autoClose: 2000,
                        theme: "colored",
                        className: 'rotateY animated',
                        transition: Flip
                    });
                });
        }

    }, [])

    function addProject() {
        if (editProjectList.length >= 5) {
            toast.warning(t("vod.manage.editor_tab.max_projects_limit"), {
                position: "top-center",
                autoClose: 2000,
                theme: "colored",
                className: 'rotateY animated',
                transition: Flip
            });
        }
        else {
            toastId.current = toast.info(t("vod.manage.editor_tab.creating_project"), {
                position: "top-center",
                autoClose: 2000,
                theme: "colored",
                className: 'rotateY animated',
                transition: Flip
            });

            api({
                method: 'post',
                url: '/editor/create',
                data: {
                    tk: userToken,
                    uuid: uuid,
                    ogc: organizationData.organization_code,
                }
            })
                .then((response) => {
                    console.log(response.data)
                    if (response.data.code == 100) {
                        var tmpList = [...editProjectList];
                        tmpList.push({
                            id: response.data.data,
                            label: "new Project",
                            uuid: vodInfo.uuid,
                            state: 1
                        });
                        setEditProjectList(tmpList);
                        dispatch(setEditProjList(tmpList));
                        toast.update(toastId.current, {
                            render: t('vod.manage.editor_tab.project_created_success'),
                            type: "success",
                            position: "top-center",
                            autoClose: 3000,
                            transition: Flip,
                            theme: "colored",
                        });
                    }
                    else {
                        toast.update(toastId.current, {
                            render: t('vod.manage.editor_tab.project_creation_error'),
                            type: "warning",
                            position: "top-center",
                            autoClose: 3000,
                            transition: Flip,
                            theme: "colored",
                        });
                    }
                })
                .catch((error) => {
                    toast.update(toastId.current, {
                        render: t('vod.manage.editor_tab.project_creation_error'),
                        type: "warning",
                        position: "top-center",
                        autoClose: 3000,
                        transition: Flip,
                        theme: "colored",
                    });
                });
        }
    }

    function handleDeleteClick(idx) {
        setProjectToDelete(idx);
        setOpenDeleteModal(true);
    }

    function handleCloseDeleteModal() {
        setOpenDeleteModal(false);
        setProjectToDelete(null);
    }

    function confirmDelete() {
        if (projectToDelete !== null) {
            deleteProject(projectToDelete);
        }
        handleCloseDeleteModal();
    }

    function deleteProject(idx) {
        toastId.current = toast.info(t("vod.manage.editor_tab.deleting_project"), {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
            className: 'rotateY animated',
            transition: Flip
        });

        api({
            method: 'delete',
            url: '/editor/delete',
            data: {
                tk: userToken,
                uuid: uuid,
                ogc: organizationData.organization_code,
                project_id: editProjectList[idx].id
            }
        })
            .then((response) => {
                console.log(response.data)
                if (response.data === true) {
                    var tmpList = [...editProjectList];
                    tmpList.splice(idx, 1);
                    setEditProjectList(tmpList);
                    dispatch(setEditProjList(tmpList));

                    toast.update(toastId.current, {
                        render: t('vod.manage.editor_tab.project_deleted_success'),
                        type: "success",
                        position: "top-center",
                        autoClose: 3000,
                        transition: Flip,
                        theme: "colored",
                    });
                }
                else {
                    toast.update(toastId.current, {
                        render: t('vod.manage.editor_tab.project_deletion_error'),
                        type: "warning",
                        position: "top-center",
                        autoClose: 3000,
                        transition: Flip,
                        theme: "colored",
                    });
                }
            })
            .catch((error) => {
                toast.update(toastId.current, {
                    render: t('vod.manage.editor_tab.project_deletion_error'),
                    type: "warning",
                    position: "top-center",
                    autoClose: 3000,
                    transition: Flip,
                    theme: "colored",
                });
            });
    }

    function openProject(idx) {
        setIsLoading(true);

        api({
            method: 'post',
            url: '/editor/getInfo',
            data: {
                tk: userToken,
                uuid: uuid,
                ogc: organizationData.organization_code,
                project_id: editProjectList[idx].id
            }
        })
            .then((response) => {
                setIsLoading(false);

                if (response.data.code == 100) {

                    navigate(`/vod/${uuid}/editor/${editProjectList[idx].id}`);
                    dispatch(setEditProjIdx(editProjectList[idx].id));
                    dispatch(setProjectInfo(response.data.projectInfo));

                    // 빈 array 들어가는 것 방지
                    if (Object.keys(response.data.projectData).length === 0) {
                        console.log('Setting empty projectData array');
                        dispatch(setProjectData([]));
                    }
                    else {
                        console.log('Setting projectData:', response.data.projectData);
                        dispatch(setProjectData(response.data.projectData));
                    }
                }
                else {
                    toast.update(toastId.current, {
                        render: t('vod.manage.editor_tab.failed_to_load_project_list'),
                        type: "error",
                        position: "top-center",
                        autoClose: 3000,
                        className: 'rotateY animated',
                        transition: Flip,
                        theme: "colored",
                    });
                }
            })
            .catch((error) => {
                toast.update(toastId.current, {
                    render: t('vod.manage.editor_tab.failed_to_load_project_list'),
                    type: "error",
                    position: "top-center",
                    autoClose: 3000,
                    className: 'rotateY animated',
                    transition: Flip,
                    theme: "colored",
                });
            });
    }

    return (
        <div style={{ width: '100%' }}>
            {
                isFetched ?
                    <>
                        <TableContainer component={Paper} elevation={0}>
                            <Table className="table-edit-project" style={{ marginBottom: 0 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">{t('vod.manage.editor_tab.project')}</TableCell>
                                        <TableCell align="center">{t('vod.manage.editor_tab.date')}</TableCell>
                                        <TableCell align="center">{t('buttons.delete')}</TableCell>
                                        <TableCell align="center">{t('buttons.edit')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        editProjectList.map((el, idx) => (
                                            <TableRow key={idx} className="tr-edit-project">
                                                <TableCell align="center">{el.label}</TableCell>
                                                <TableCell align="center">2023.10.22</TableCell>
                                                <TableCell align="center" onClick={() => handleDeleteClick(idx)} style={{ cursor: 'pointer' }}><DeleteIcon className="edit-project-list__delete-icon" /></TableCell>
                                                <TableCell align="center" onClick={() => flag == 0 ? openProject(idx) : null} style={{ cursor: 'pointer' }}><ArrowForwardIosIcon /></TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {
                            isFetched && editProjectList.length < 5 ?
                                <div className="tr-edit-project-plus" onClick={() => addProject()}>
                                    <div className='btn-edit-project-plus'><AddIcon /></div>
                                </div>
                                :
                                null
                        }
                        <Dialog
                            open={openDeleteModal}
                            onClose={handleCloseDeleteModal}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{t("vod.manage.editor_tab.delete_project_confirmation")}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    {t("vod.manage.editor_tab.delete_project_warning")}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseDeleteModal}>{t('buttons.cancel')}</Button>
                                <Button onClick={confirmDelete} autoFocus>
                                    {t('buttons.delete')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </>
                    :
                    <LoadingComponent />
            }
        </div>
    );
}

export default EditProjectList;
